import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard, BillingPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import SettingsLayout from 'src/sections/settings/components/settings-layout';

const BillingSettingsPage = lazy(() => import('src/pages/settings/billing'));
const GeneralSettingsPage = lazy(() => import('src/pages/settings/general'));
const UsersPage = lazy(() => import('src/pages/settings/users'));
const MultiStorePage = lazy(() => import('src/pages/settings/MultiStorePage'));

export const settingsRoutes = [
  // Billing page needs special guard that doesn't require valid subscription
  // (since this is where users go to fix their subscription)
  {
    path: 'settings/billing',
    element: (
      <BillingPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <SettingsLayout>
            <Suspense fallback={<LoadingScreen />}>
              <BillingSettingsPage />
            </Suspense>
          </SettingsLayout>
        </AppLayout>
      </BillingPolicyGuard>
    ),
  },
  // Other settings pages require valid subscription
  {
    path: 'settings',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <SettingsLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </SettingsLayout>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <Navigate to="general" replace />, index: true },
      { path: 'general', element: <GeneralSettingsPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'multi-store', element: <MultiStorePage /> },
    ],
  },
];
